import { Toast } from 'antd-mobile';

import { EAPP_CHANNEL_VALUE, getAppChannelValue, isDouyinAppChannel } from './code';
import { canIUseTiktokSDK } from './utils';
import { fetchDouyinCustomerServiceLink } from '@/apis/order';

function formatPhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/[^\d+\-\s()]/g, '');
}

export const callPhoneForUnionPaySDK = (phoneNumber: string): void => {
  if (!phoneNumber) {
    console.error('电话号码不能为空');
    return;
  }
  const cleanNumber = formatPhoneNumber(phoneNumber);

  if (typeof window !== 'undefined' && window.location) {
    const telLink = `tel:${cleanNumber}`;
    window.location.href = telLink;
  }
};

export const callPhoneForTiktok = (phoneNumber: string): void => {
  if (!phoneNumber) {
    console.error('电话号码不能为空');
    return;
  }

  if (canIUseTiktokSDK && tt) {
    const cleanNumber = formatPhoneNumber(phoneNumber);

    console.info('[callPhoneForTiktok] calling phone:', cleanNumber);

    tt.miniProgram.postMessage({
      data: {
        mes: `call_phone:${cleanNumber}`,
      },
      success: () => {
        console.info('[callPhoneForTiktok] call phone success');
      },
      fail: (err) => {
        console.error('[callPhoneForTiktok] call phone failed:', err);
        Toast.show('拨打失败');
      },
    });

    setTimeout(() => {
      tt.miniProgram.navigateTo({ url: '/pages/web-view/index' });
      tt.miniProgram.navigateBack({ delta: 1 });
    }, 0);
  }
};

export const channelCallPhone = (phoneNumber: string): void => {
  const _channel = getAppChannelValue();

  if (_channel === EAPP_CHANNEL_VALUE.UNIONPAY) {
    callPhoneForUnionPaySDK(phoneNumber);
  } else if (_channel === EAPP_CHANNEL_VALUE.DOUYIN) {
    callPhoneForUnionPaySDK(phoneNumber);
  }
};

export const channelCallCustomerService = (phoneNumber?: string, orderId?: string): void => {
  const _channel = getAppChannelValue();

  if (_channel === EAPP_CHANNEL_VALUE.DOUYIN && canIUseTiktokSDK && tt) {
    fetchDouyinCustomerServiceLink(orderId || '')
      .then((res) => {
        if (res && res.url) {
          tt.miniProgram.openCustomerServiceChat({
            url: res.url,
            success: () => {
              console.info('[channelCallCustomerService] Douyin customer service opened');
            },
            fail: (err) => {
              console.error('[channelCallCustomerService] Douyin customer service failed:', err);
              Toast.show('打开客服失败！');
            },
          });
        } else {
          console.warn('[channelCallCustomerService] No URL returned from API');
          Toast.show('获取客服链接失败！');
        }
      })
      .catch((err: Error) => {
        console.error('[channelCallCustomerService] fetchDouyinCustomerServiceLink error:', err);
        Toast.show('获取客服链接失败！');
      });
  }
};

export { isDouyinAppChannel };
